<template>
  <div
    :style="
      `
        color: ${color};
        --ai-icon-stroke-width: ${strokeWidth};
        --ai-icon-width: ${width};
        --ai-icon-height: ${height};
      `
    "
    class="inline-block svg"
    v-html="require(`!html-loader!../../assets/svg/${icon}.svg`)"
  ></div>
</template>

<style lang="scss">
.svg svg {
  width: var(--ai-icon-width);
  height: var(--ai-icon-height);
  vertical-align: middle;
  path {
    fill: currentColor;
    stroke: currentColor;
    stroke-width: var(--ai-icon-stroke-width);
  }
  clipPath rect {
    width: 100%;
    height: 100%;
  }
}
</style>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '1rem'
    },
    height: {
      type: String,
      default: '1rem'
    },
    color: {
      type: String,
      default: 'inherit'
    },
    thickness: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    strokeWidth() {
      if (typeof this.thickness === 'number') return this.thickness + 'px';
      return this.thickness;
    },
    svgComponent() {
      if (this.$slots.default || this.icon) {
        const slotText = this.icon || this.$slots.default[0].text?.trim();

        return require(`../../assets/svg/${slotText}.svg`);
      }

      return false;
    }
  }
};
</script>
